module.exports = __webpack_public_path__ + "img/other-icon-img9.8ff2692c.svg";